export default {
  namespace: 'parse',
  state: {},
  reducers: {}
};



// WEBPACK FOOTER //
// ./src/pages/parse/models/parse.js